export default __webpack_public_path__ + "static/media/recording.eec17332.png";